/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { Checkbox } from '@motili/ui';
import { ChangeEvent, ReactElement } from 'react';
import { styled } from 'styled-components';
import { useAppDispatch } from '../../../common/redux/hooks';
import { setTeamInfo } from '../../../common/redux/ducks/contractorRegistrationForm';
import { TeamInfo } from '../../../common/types';

interface ServiceProviderCheckboxOptionsProps {
    teamInfo: TeamInfo;
}

const checkBoxOptions = [
    {
        label: 'Single Family',
        name: 'singleFamilyServiceProvider',
    },
    {
        label: 'Multi Dwelling',
        name: 'multiDwellingServiceProvider',
    },
    {
        label: 'Commercial',
        name: 'commercialServiceProvider',
    },
];

export default function ServiceProviderCheckboxOptions({
    teamInfo,
}: ServiceProviderCheckboxOptionsProps): ReactElement {
    const dispatch = useAppDispatch();
    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        dispatch(
            setTeamInfo({
                ...teamInfo,
                [event.target.name]: event.target.checked,
            })
        );
    };

    const createCheckBoxOptions = () => {
        return checkBoxOptions.map(option => (
            <StyledCheckbox
                key={option.name}
                label={option.label}
                onChange={handleCheckboxChange}
                checked={!!teamInfo[option.name as keyof TeamInfo]}
                name={option.name}
                value={'false'}
                id={option.name}
            />
        ));
    };

    return <>{createCheckBoxOptions()}</>;
}

const StyledCheckbox = styled(Checkbox)`
    margin-top: 10px;
`;
